import { useState } from 'react';

const SUBMIT_URL = 'https://readdy.ai/api/form/da08ra6859p3u981e15g';

export default function NewsletterForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = (fd.get('website_alt') as string)?.trim() ?? '';

    // 蜜罐命中：不给机器人明确信号，伪装成正常成功
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功，欢迎加入动漫网的二次元大家庭！');
      form.reset();
      return;
    }

    fd.delete('website_alt');
    setStatus('loading');
    setMessage('');
    try {
      const res = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let code = '';
      let serverMsg = '';
      try {
        const parsed = JSON.parse(responseText);
        code = parsed?.code ?? '';
        serverMsg = parsed?.meta?.message ?? parsed?.message ?? parsed?.meta?.detail ?? '';
      } catch {
        serverMsg = responseText;
      }
      if (res.ok && code === 'OK') {
        setStatus('success');
        setMessage('订阅成功，欢迎加入动漫网的二次元大家庭！');
        form.reset();
      } else {
        setStatus('error');
        setMessage(serverMsg || '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后再试。');
    }
  };

  return (
    <form data-readdy-form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col sm:flex-row gap-2">
        <label className="sr-only" htmlFor="newsletter-email">邮箱地址</label>
        <input
          id="newsletter-email"
          type="email"
          name="email"
          required
          placeholder="输入邮箱地址"
          className="flex-1 rounded-full border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap disabled:opacity-60"
        >
          {status === 'loading' ? '提交中…' : '订阅'}
        </button>
      </div>
      {/* 反垃圾蜜罐字段 */}
      <input
        type="text"
        name="website_alt"
        className="hp-field"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      {status === 'success' && (
        <p className="mt-2 text-xs text-secondary-500" role="status">{message}</p>
      )}
      {status === 'error' && (
        <p className="mt-2 text-xs text-primary-600" role="alert">{message}</p>
      )}
    </form>
  );
}